import { useContext } from 'react'
import { AuthContext } from '@/contexts/auth-context'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'

function ProfileBanner() {
  const { auth } = useContext(AuthContext)
  const navigate = useNavigate()

  const isProfileIncomplete = () => {
    const requiredFields = [
      'name',
      'address',
      'city',
      'state',
      'postal_code',
      'country',
      'gender',
      'dob',
    ]

    if (!auth?.user) return false

    return requiredFields.some((field) => {
      const value = auth.user[field]
      // Check for null, undefined, or empty string. For name, ensure it's not just whitespace.
      if (field === 'name') {
        return value === null || value === undefined || value.trim() === ''
      }
      return value === null || value === undefined || value === ''
    })
  }

  // Only show the banner if the user is a 'user' role and profile is incomplete
  if (auth?.user?.role !== 'user' || !isProfileIncomplete()) {
    return null
  }

  return (
    <div className="w-full bg-yellow-50 border-l-4 border-yellow-500 text-yellow-800 px-6 py-3 shadow-sm">
      <div className="max-w-7xl mx-auto flex justify-end items-center">
        {' '}
        {/* Changed to justify-end */}
        {/* We assume the Header component also uses max-w-7xl mx-auto and its content starts from left.
            By using justify-end here, the banner content will align to the right side of the main content area,
            effectively "pushing" it away from where the logo is. */}
        <p className="text-sm mx-auto">
          {' '}
          {/* Added mr-4 for spacing */}
          Your profile is incomplete. Please complete your profile to get the best experience.
        </p>
        <Button
          variant="outline"
          onClick={() => navigate('/user/profile/edit')}
          className="text-yellow-700 border-yellow-500 hover:bg-yellow-100 hover:border-yellow-600 px-4 py-2" // Added px-4 py-2 for button padding
        >
          Complete Profile
        </Button>
      </div>
    </div>
  )
}

export default ProfileBanner
